"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.authorize = void 0;
const create_error_1 = require("../create-error");
const error_interfaces_1 = require("../types/error.interfaces");
const http_interfaces_1 = require("../types/http.interfaces");
/**
 * Does request authorization in following steps.
 * - First, the logic decorates request with provided auth resource.
 * - Then, the logic sends the response to claim resolver.
 * - Then, the logic resubmits the request when claim resolver provides a request with refreshed token.
 * - Finally, the logic returns a last response.
 * @param send The base send
 * @param auth Authorization resource
 */
const authorize = (send, auth) => async (plainRequest) => {
    // Do header's authentication
    const authorizeStep = plainRequest.operationLogger.logStep(http_interfaces_1.OperationLogEntryType.AuthDecorate);
    const authResult = await safeAuthorize(plainRequest, auth);
    authorizeStep && authorizeStep({ result: http_interfaces_1.Status[http_interfaces_1.Status.OK] });
    if (!authResult) {
        throw (0, create_error_1.createError)(error_interfaces_1.ErrorReason.AuthFailed);
    }
    const authRequest = authResult.request;
    const response = await send(authRequest);
    const request = (await safeResolveClaim(response, authRequest, authResult.resolver));
    if (request) {
        request.operationLogger.nextStep(http_interfaces_1.OperationLogEntryType.Auth, { result: http_interfaces_1.Status[response.status] }, request, response);
        return send(request);
    }
    return response;
};
exports.authorize = authorize;
/** Safely call provided auth resource */
const safeAuthorize = async (request, auth) => {
    try {
        return await auth(request);
    }
    catch (e) {
        throw (0, create_error_1.createError)(error_interfaces_1.ErrorReason.AuthFailed, undefined, e);
    }
};
/** Safely call provided auth claim resolver */
const safeResolveClaim = async (response, request, resolver) => {
    const resolveOp = request.operationLogger.beginStep(http_interfaces_1.OperationLogEntryType.AuthResolve, request);
    try {
        const resolvePromise = resolver(response, request);
        resolvePromise.then((resolvedRequest) => {
            resolveOp &&
                resolvedRequest &&
                resolveOp({ result: http_interfaces_1.Status[response.status] }, response);
            return resolvedRequest;
        });
        return await resolvePromise;
    }
    catch (e) {
        throw (0, create_error_1.createError)(error_interfaces_1.ErrorReason.AuthResolveFailed, response, e);
    }
};
